export default {
    accountSupport: {
        defaults: {
            endpoint: 'crud.php?property=AccountSupport', // scope: data_point_type_id=9999
            rootProperty: 'account_support',
        },
        read: {
            params: { action: 'get' }
        },
        create: {
            params: { action: 'create' },
        },
        update: {
            params: { action: 'update' },
        },
        destroy: {
            params: { action: 'delete' },
        }
    }
}
